import { Button, DialogContainer, Input, Text } from '@components'
import type { Profile } from '@here/api'
import { User } from 'lucide-solid'
import { For, Show } from 'solid-js'
import { useService } from 'solid-services'
import { Grid } from 'styled-system/jsx'
import { flex } from 'styled-system/patterns'
import { useUi } from '../state'
import { useMention } from '../state/useMention'

export const Mention = () => {
	const { isMentionOpen, setIsMentionOpen } = useService(useUi)()
	const { profilesResource, setSearchTerm, setActiveMentions } =
		useService(useMention)()

	const onClick = (profile: Profile) => {
		setIsMentionOpen(false)
		setActiveMentions((prev) => [...prev, profile])
	}

	// TODO make this keyboard naviagte and selectable
	return (
		<Show when={isMentionOpen()}>
			<DialogContainer
				title="Mention user"
				isOpen={isMentionOpen()}
				setIsOpen={setIsMentionOpen}
			>
				<Grid>
					<Input
						autofocus
						onInput={({ target }) => setSearchTerm(target.value)}
					/>
					<Grid
						height="220px"
						overflow="auto"
						alignContent="start"
					>
						<For each={profilesResource()}>
							{(profile) => (
								<Button
									variant="ghost"
									onClick={() => onClick(profile)}
									class={flex({
										justifyContent: 'space-between',
									})}
								>
									<Text>{profile.username}</Text>
									<User />
								</Button>
							)}
						</For>
					</Grid>
				</Grid>
			</DialogContainer>
		</Show>
	)
}
